import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-su_012",
  "use": "icon-su_012-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-su_012\"><defs><style>#icon-su_012 .cls-1{fill:none;opacity:0;}</style></defs><g id=\"icon-su_012_レイヤー_2\" data-name=\"レイヤー 2\"><g id=\"icon-su_012_icon\"><rect class=\"cls-1\" width=\"24\" height=\"24\" /><rect class=\"cls-2\" x=\"4\" y=\"6\" width=\"12\" height=\"16\" /><polygon class=\"cls-2\" points=\"20 18 18 18 18 4 8 4 8 2 20 2 20 18\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol